import { useCallback, useEffect, useState } from 'react';
import useTask from '../../../../modules/tasks/hooks/use-task';
import QuestionBox from '../../../question-box';
import Task302Game from './game';
import './style.scss';

type Props = {
    onComplete?: () => void
}

const Task302: React.FC<Props> = ({ onComplete: completeCallback }) => {

    const onComplete = useCallback(() => {
        if (completeCallback) {
            completeCallback();
        }
    }, [completeCallback]);

    const { task } = useTask('t-302');


    const [complete1, setComplete1] = useState(false);
    const [complete2, setComplete2] = useState(false);

    useEffect(() => {
        if (complete1 && complete2) {
            onComplete();
        }
    }, [complete1, complete2, onComplete])


    return <div className="task task-302">
        <h2>zadanie 2</h2>
        <h3>{task?.title}</h3>
        <p>
            Spotkaliście się kiedyś z określeniem “chochlik drukarski”? To potoczna nazwa błędu w druku. Dziełem chochlika są błędy poważniejsze niż zwykłe literówki, nieoczywiste lub ukryte w taki sposób, że nie powstały wskutek przypadku. Właśnie taki stworek pomieszał wersy w ciekawostkach o tegorocznych patronach literackich!
        </p>
        <p className="instruction">
            <strong>Zadanie:</strong> Uporządkujcie wersy z ciekawostek dotyczących dwóch patronów, przeciągając odpowiedni wers w dobre miejsce.
        </p>
        <h3>Stanisław Lem</h3>
        <Task302Game id="lem" onComplete={() => setComplete1(true)} data={[
            'Ten polski pisarz urodził się',
            'dzień przed upadkiem pierwszego rządu Wincentego Witosa.',
            'W czasie II wojny światowej',
            'studiował medycynę i',
            'pracował jako pomocnik mechanika i spawacz w niemieckiej firmie.',
            'Ostatnią napisaną przez niego powieścią była „Fiasko”,',
            'która opowiada o spotkaniu Ziemian z',
            'obcą cywilizacją.',
            'Uwielbiał chałwę i marcepan, nie chciał z tych przysmaków zrezygnować nawet wtedy, gdy',
            'zachorował na cukrzycę.',
            'Otrzymał 5 doktoratów Honoris Causa.',
            'Choć sam nigdy nie poleciał w kosmos, to',
            'w przestrzeni kosmicznej znalazły się aż dwa obiekty ochrzczone jego nazwiskiem:',
            'pierwszy polski sztuczny satelita naukowy oraz planetoida'
        ]} />

        <h3>Cyprian Kamil Norwid</h3>
        <Task302Game id="norwid" onComplete={() => setComplete2(true)} data={[
            'Urodził się',
            'gdy Polska nie występowała na mapach.',
            'Był dumny z tego, że',
            'był krewnym króla Jana III Sobieskiego.',
            'Przez dużą część życia był głuchy.',
            'Jego kłopoty ze słuchem najprawdopodobniej wiązały się z',
            'tajemniczym uwięzieniem w Berlinie w czerwcu 1846 r.',
            'Brzmienie jego nazwiska sugeruje',
            'jego litewskie pochodzenie',
            'a oznacza “ten, który chce widzieć”,',
            'Przez trzy lata mieszkał w Paryżu, gdzie',
            'spotkał Juliusza Słowackiego i Fryderyka Chopina.',
            'Na początku lat 70. XX w.',
            'jego twórczość popularyzował Czesław Niemen.'
        ]} />

        <QuestionBox>
            <p>
                W tym roku mamy aż czterech Patronów Literackich!<br /> Są to Krzysztof Kamil Baczyński, Cyprian Kamil Norwid, Stanisław Lem oraz Tadeusz Różewicz.<br /> Znacie jakieś ciekawostki dotyczące pozostałych dwóch?
            </p>
        </QuestionBox>
    </div>
}

export default Task302;
